/**
 * vipupiste_focus.v1 — the ticks the lock panel starts from. The same rule as
 * the backend's copy (apps/backend/src/modules/vipupiste_focus_v1/selection.js);
 * specs/workshop-modules/vipupiste_focus.md → The lock.
 *   keep:  the top half by votes, with everything tied at the cut-off; with no votes, every one.
 *   prune: every one except the half with the most votes against (ties at the cut-off go too);
 *          one nobody voted against always stays.
 */
export function defaultSelection(ids, counts, mode) {
  const n = (id) => counts[id] || 0;
  if (!ids.length) return [];
  const voted = ids.filter((id) => n(id) > 0);
  if (!voted.length) return [...ids];
  const ranked = [...voted].sort((a, b) => n(b) - n(a));
  const half = Math.ceil(ids.length / 2);
  const cut = n(ranked[Math.min(half, ranked.length) - 1]);
  const top = new Set(ranked.filter((id, i) => i < half || n(id) === cut));
  return mode === 'prune' ? ids.filter((id) => !top.has(id)) : ids.filter((id) => top.has(id));
}

/** The vipupisteet by votes, most first; ties keep the map's order. */
export function byVotes(vipupisteet, counts) {
  return vipupisteet.map((v, i) => [v, i])
    .sort(([a, i], [b, j]) => (counts[b.id] || 0) - (counts[a.id] || 0) || i - j)
    .map(([v]) => v);
}
